/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Tab_ReportInputs */



/**
* | output |
* | --- |
* | "Report" |
*
* @param {Meeting_Tab_ReportInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_tab_report = /** @type {((inputs?: Meeting_Tab_ReportInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Tab_ReportInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Verslag")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Compte rendu")
	return /** @type {LocalizedString} */ ("Report")
});